import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import { addNotifications } from "../../../../toaster/ToasterPortalSlice";
import { TOASTER_VARIANT } from "../../../../../components/toast/constants";
import IntegrationDataService from "../../../../../../services/IntegrationDataService";
import FormsDataService from "../../../../../../services/FormsDataService";
import General from "../../../../../../libs/utility/General";
import { componentKey, setFormSettings, setImportData, setIsImportDataGridViewLoaded, setLoadingState } from "./PlugInSlice";
import { QBD_LOADING_STATES } from "../../constants";

export const { getLoadImportData, getFormSetting, qbPluginDownload } = {


    getLoadImportData: (payload) => {
        return {
            type: "QBD_PLUGIN/GET_LOAD_IMPORT_DATA",
            payload: payload
        }
    },
    getFormSetting: (payload) => {
        return {
            type: "QBD_PLUGIN/GET_FORM_SETTING",
            payload: payload
        }
    },

    qbPluginDownload: (payload) => {
        return {
            type: "QBD_PLUGIN/GET_PLUGIN_DOWNLOAD",
            payload: payload
        }
    },
}

function* getLoadImportDataAsync(action) {
    try {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.PAGE_LOADING }));
        const { integrationImportRequestDto } = action.payload;
        const response = yield IntegrationDataService.getIntegrationImportData(integrationImportRequestDto);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setImportData(response?.data?.Data));
            yield put(setIsImportDataGridViewLoaded(true));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch Import Data", message: error?.response?.data?.Message }));
    }
    finally {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.PAGE_DATA_READY }));
    }
}
function* getFormSettingAsync(action) {
    try {
        const { formId, year } = action.payload;
        const response = yield FormsDataService.getFormSetting(formId, year);
        if (response?.data) {
            if (response?.data?.Status === 1) {
                yield put(setFormSettings(response?.data?.Data));
            } else {
                yield put(addNotifications({ heading: "Error", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    }
  
}

function* qbPluginDownloadAsync() {
    try {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.FILE_DOWNLOADING }));
        const response = yield IntegrationDataService.qbPlugInDownload();
        if (response?.data?.Status === 1) {
            const { Base64, Name } = response?.data?.Data;
            General.downloadFile(Base64, Name);
        } else {
            yield put(addNotifications({ heading: "Error", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.FILE_DOWNLOADING_READY }));
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getLoadImportData().type, getLoadImportDataAsync),
        takeLatest(getFormSetting().type, getFormSettingAsync),
        takeLatest(qbPluginDownload().type, qbPluginDownloadAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);